import { message } from 'antd';

export const alertSuccess = (content, duration) => {
  return message.success({content, duration, className: 'alert-success'});
}

export const alertFail = (content, duration) => {
  return message.error({content, duration, className: 'alert-fail'});
}
